import { TTariffProfileRule } from '../../../core/tariff-profile';
import { TTariffType } from '../../../core/tariff-type';
import { TTariffZone } from '../../../core/tariff-zone';
import { TTerminalType } from '../../../core/terminal-type';

export type TariffProfileRulesRow = {
  terminalType: TTerminalType;
  tariffType: TTariffType;
  zone: TTariffZone;
  rule: TTariffProfileRule | null;
};

export type TariffProfileRulesRecord = TariffProfileRulesRow & {
  isEmpty: boolean;
};

export const enum ERuleValueType {
  amount = 'amount',
  percent = 'percent',
}
